// used for posed animation properties

export default {
  preEnterPosition: 400,
  duration: 300,
  stiffness: 150,
  type: 'spring',
  damping: 100,
}
